// import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify';
import es from 'vuetify/es5/locale/es';
import 'vuetify/dist/vuetify.min.css';
import colors from 'vuetify/lib/util/colors';
// import colors from 'vuetify/es5/util/colors';

Vue.use(Vuetify);

// SARICO

export default new Vuetify({
	theme: {
		options: {
			customProperties: true,
		},
		themes: {
			light: {
				primary: colors.amber.darken1,		// #FFB300
				secondary: colors.brown.darken1,	// #6D4C41
				accent: colors.deepOrange.base,		// #FF5722
				featured: colors.amber.lighten5,	// #FFF8E1
				// error:		'#FF5252'
				// warning:	'#FFC107'
				// info:		'#2196F3'
				// success:	'#4CAF50'
			},
			default: {
				primary: colors.amber.darken1,		// #FFB300
				secondary: colors.brown.darken1,	// #6D4C41
				accent: colors.deepOrange.base,		// #FF5722
				featured: colors.amber.lighten5,	// #FFF8E1
			},
			
		},
	},
	lang: {
		locales: { es },
		current: 'es',
	},
	icons: {
		iconfont: 'mdi'
	}
	
});
